import { useAtomValue } from "jotai";
import { datasetsAtom } from "datasheets/model/atoms/WorkbookFocusAtoms";
import { PropertySet } from "datasheets/model/core/Workbook";
import { KeyedElementSelection } from "./KeyedElementSelection";

export function allColumnsForDataset(properties: PropertySet) {
  return Object.values(properties.nameToKey).reduce(
    (prev: { [index: number]: string }, key: string, index: number) => {
      prev[index + 1] = key; // Column indices are 1 based, while dict is 0 based
      return prev;
    },
    {}
  );
}

export function ColumnSelector({
  title,
  datasetId,
  propertySet,
  selection,
  onChange,
  isSingleSelection,
  showTitle = true,
}: {
  title: string;
  showTitle?: boolean;
} & (
  | {
      datasetId: string | undefined;
      propertySet?: null;
    }
  | { datasetId?: null; propertySet: PropertySet }
) &
  (
    | {
        selection: string[];
        onChange: (columns: { [index: number]: string }) => void;
        isSingleSelection: false;
      }
    | {
        selection?: string;
        onChange: (column: string) => void;
        isSingleSelection: true;
      }
  )) {
  const datasets = useAtomValue(datasetsAtom);
  let properties;
  if (datasetId) {
    const dataset = datasets[datasetId];
    properties = dataset?.properties;
  } else {
    properties = propertySet;
  }
  if (!properties) {
    return <></>;
  }
  const allColumns = allColumnsForDataset(properties);
  const unselectedColumns = !!isSingleSelection
    ? []
    : Object.values(allColumns).filter((key) => !selection.includes(key));

  return (
    <KeyedElementSelection
      showTitle={showTitle}
      title={title}
      labelToKey={properties.nameToKey}
      keyToLabel={properties.keyToName}
      selection={selection}
      availableKeys={unselectedColumns}
      onChange={onChange}
      isSingleSelection={isSingleSelection}
    />
  );
}
